import { ApolloLink } from '@apollo/client'

import { APP } from 'Config'

import { Session } from 'Services/Store/Session'

function createAuthLink() {
  return new ApolloLink((operation, forward) => {
    operation.setContext(
      (prevContext: Record<string, Record<string, unknown>>) => {
        const accessToken = Session.getAccessToken()

        return {
          headers: {
            ...prevContext.headers,
            Authorization: accessToken ? `Bearer ${accessToken}` : null,
            'Organization-Id': APP.ORGANIZATION_ID,
          },
        }
      },
    )

    return forward(operation)
  })
}

export default createAuthLink
